import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { useFetchWrapper as Api } from "../../utils";


const initialState: any = {
  loading: false,
  rows: [],
  count: 0,
  // categoryAddEditLoader:false
};
export const getDeviceData: any = createAsyncThunk(
  "deviceManagement/getDeviceData",
  async (apiPath) => {
    let data = await Api().get(apiPath);
    return data;
  }
);


export const deviceManagementSlice = createSlice({
  name: 'deviceManagement',
  initialState,
  reducers: {
    // setCategoryAddEditLoader: (state: any, { payload }) => {
    //   state.categoryAddEditLoader = payload;
    //   state.loading = payload;
    // },
    addNewRow: (state: any, { payload }) => {
      state.rows = [...state.rows, payload];
    },
    removeRow: (state: any, { payload }) => {
      let tableRowsAfterRemovingEditRow = state.rows.filter(
        (item: any) => item.CategoryID !== payload.CategoryID
      );
      state.rows = [...tableRowsAfterRemovingEditRow];
    },
    deleteRow: (state: any, { payload }) => {
      state.rows = state.rows.filter(
        (item: any) => item.CategoryID !== payload
      );
    },
    resetDeviceMangementData: (state: any) => {
      state.loading = false;
        state.rows = [];
        state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getDeviceData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDeviceData.fulfilled, (state, action) => {
      state.loading = false;
      state.rows = action?.payload?.data?.records;
      state.count = action?.payload?.data?.total_count;
    });
    builder.addCase(getDeviceData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Action creators are generated for each case reducer function
// export const { } = hashcardSlice.actions;
export const { addNewRow, removeRow, deleteRow, resetDeviceMangementData } = deviceManagementSlice.actions;

export default deviceManagementSlice.reducer;